import { forwardRef } from 'react';
import { Typography } from '../Typography/Typography.js';
import { getEmptyStateStyles, getEmptyStateImageStyles, getIconStyles, getArticleExtraMargin, getTitleStyles, getSubtitleStyles } from './EmptyStateStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';
import { IconSize } from '../Icon/types/size.js';

const EmptyState = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    title,
    alt = title,
    src,
    subtitle,
    imageBlackAndWhite,
    isElevated = true,
    headerIcon,
    headerImage: headerImageProps,
    children,
    ...rest
  } = _ref;
  /**
   * ToDo: This will removed with Giger 69, as headerImage from props will the only one
   */
  const headerImage = headerImageProps !== null && headerImageProps !== void 0 ? headerImageProps : {
    src,
    alt
  };
  return jsxs("section", {
    css: getEmptyStateStyles(isElevated),
    ...rest,
    ref: ref,
    children: [headerImage.src && jsx("img", {
      css: getEmptyStateImageStyles(imageBlackAndWhite),
      src: headerImage.src,
      alt: headerImage.alt
    }), headerIcon && jsx(Icon, {
      css: getIconStyles,
      name: headerIcon,
      size: IconSize.SIZE_EXTRA_LARGE
    }), jsxs("article", {
      css: children && getArticleExtraMargin,
      children: [jsx(Typography, {
        component: "p",
        variant: "subtitle2",
        variantTablet: "heading5",
        bold: true,
        css: getTitleStyles,
        children: title
      }), subtitle && jsx(Typography, {
        component: "p",
        variant: "body1",
        css: getSubtitleStyles,
        children: subtitle
      })]
    }), children]
  });
});
EmptyState.displayName = 'EmptyState';

export { EmptyState };
//# sourceMappingURL=EmptyState.js.map
